import React, { useState } from "react";
import clsx from "classnames";
import classes from "./styles.module.scss";
import ResourceCard from "../ResourceCard";

export default function Paginations({ resources, className }) {
  
  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastResource = currentPage * itemsPerPage;
  const indexOfFirstResource = indexOfLastResource - itemsPerPage;
  const currentResources = resources.slice(indexOfFirstResource, indexOfLastResource);

  const totalPages = Math.ceil(resources.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className={clsx(className, classes.listings)}>
      <div className={classes.items}>
        {currentResources.map((item, index) => (
          <ResourceCard key={index} resource={item} />
        ))}
      </div>
      <div className={classes.pagination}>
        <button
          className={classes.left_btn}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/icons/left-pagination-arrow.png" alt="left-pagination-arrow"/>
        </button>
        <div className={classes.page_counter}>
          <span>{currentPage}</span> - {totalPages}
        </div>
        <button
          className={classes.right_btn}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img src="/icons/right-pagination-arrow.png" alt="right-pagination-arrow"/>
        </button>
      </div>
    </div>
  );
}

Paginations.defaultProps = {
  className: "",
};